import { DataMapper } from 'modules/core/domain/interfaces/data-mapper';

import { AvailableOrganizerDto } from '../interfaces/available-organizer-dto';
import { AvailableOrganizer } from '../interfaces/available-organizer';

export class AvailableOrganizerDataMapper implements DataMapper<AvailableOrganizer, AvailableOrganizerDto> {
  public decode(encoded: AvailableOrganizerDto): AvailableOrganizer {
    return {
      id: encoded.id,
      name: encoded.name,
      sportType: encoded.sport_type,
    };
  }

  public encode(decoded: AvailableOrganizer): AvailableOrganizerDto {
    return {
      id: decoded.id,
      name: decoded.name,
      sport_type: decoded.sportType,
    };
  }
}
